// // // 08-01-2026

// // import React, { useEffect, useState } from "react";
// // import { Plus, Download, Mail } from "lucide-react";
// // import { motion, AnimatePresence } from "framer-motion";
// // import { useNavigate } from "react-router-dom";

// // import LeadCard from "../components/leads/LeadCard";
// // import LeadForm from "../components/leads/LeadForm";
// // import LeadFilters from "../components/leads/LeadFilters";
// // import BulkEmailDialog from "../components/leads/BulkEmailDialog";

// // import api from "../api/api";
// // import { useAuth } from "../api/authContext";

// // import "../css/leads/leadspage.css";

// // export default function LeadsPage() {
// //   const navigate = useNavigate();
// //   const { token, isAdmin, role } = useAuth();

// //   console.log("AUTH CHECK:", { role, isAdmin });
// //   // const {user} = useAuth()

// //   const [leads, setLeads] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [showForm, setShowForm] = useState(false);
// //   const [editingLead, setEditingLead] = useState(null);
// //   const [searchTerm, setSearchTerm] = useState("");
// //   const [filters, setFilters] = useState({ status: "all", lead_type: "all" });
// //   const [selectedLeads, setSelectedLeads] = useState([]);
// //   const [showBulkEmail, setShowBulkEmail] = useState(false);

// //   /* ================= AUTH GUARD ================= */
// //   useEffect(() => {
// //     if (!token) {
// //       navigate("/login");
// //       return;
// //     }
// //     fetchLeads();
// //   }, [token]);

// //   /* ================= FETCH ================= */
// //   const fetchLeads = async () => {
// //     try {
// //       setLoading(true);
// //       const res = await api.get("/leads/all"); // ownership handled in backend
// //       setLeads(res.data || []);
// //     } catch (err) {
// //       console.error(err);
// //       if (err.response?.status === 401) {
// //         navigate("/login");
// //       }
// //     } finally {
// //       setLoading(false);
// //     }
// //   };



// //   const handleSave = async (data) => {
// //   console.log("editingLead:", editingLead);

// //   try {
// //     if (editingLead) {
// //       await api.put(`/leads/${editingLead._id}`, data);
// //     } else {
// //       await api.post("/leads/create", data);
// //     }
// //     fetchLeads();
// //     setShowForm(false);
// //     setEditingLead(null);
// //   } catch (err) {
// //     console.error(err.response?.data || err.message);
// //     alert("Error saving lead");
// //   }
// // };


// //   /* ================= DELETE ================= */
// //   const handleDelete = async (leadId) => {
// //     if (!window.confirm("Are you sure you want to delete this lead?")) return;

// //     try {
// //       await api.delete(`/leads/${leadId}`);
// //       setLeads(prev => prev.filter(l => l._id !== leadId));
// //       setSelectedLeads(prev => prev.filter(id => id !== leadId));
// //     } catch (err) {
// //       alert("Error deleting lead");
// //     }
// //   };

// //   /* ================= EXPORT ================= */
// //   const handleExport = () => {
// //     if (!leads.length) return;

// //     const csv = [
// //       ["Name", "Phone", "Email", "Type", "Status"],
// //       ...leads.map(l => [
// //         l.full_name,
// //         l.phone,
// //         l.email,
// //         l.lead_type,
// //         l.status
// //       ])
// //     ].map(row => row.join(",")).join("\n");

// //     const blob = new Blob([csv], { type: "text/csv" });
// //     const link = document.createElement("a");
// //     link.href = URL.createObjectURL(blob);
// //     link.download = "leads.csv";
// //     link.click();
// //   };

// //   /* ================= FILTER ================= */
// //   const filteredLeads = leads.filter(l => {
// //     const search = searchTerm.toLowerCase();
// //     return (
// //       (l.full_name?.toLowerCase().includes(search) ||
// //         l.phone?.toLowerCase().includes(search)) &&
// //       (filters.status === "all" || l.status === filters.status) &&
// //       (filters.lead_type === "all" || l.lead_type === filters.lead_type)
// //     );
// //   });

// //   /* ================= UI ================= */
// //   return (
// //     <div className="leads-page">
// //       <div className="leads-header">
// //         <div>
// //           <h1>Lead Management</h1>
// //           <p>Track and manage your leads</p>
// //         </div>

// //         <div className="actions">
// //           {selectedLeads.length > 0 && (
// //             <button onClick={() => setShowBulkEmail(true)}>
// //               <Mail size={16} /> Email ({selectedLeads.length})
// //             </button>
// //           )}

// //           <button onClick={handleExport}>
// //             <Download size={16} /> Export
// //           </button>

// //           <button
// //   onClick={() => {
// //     setEditingLead(null); // 👈 VERY IMPORTANT
// //     setShowForm(true);
// //   }}
// // >
// //   <Plus size={16} /> Add Lead
// // </button>

// //         </div>
// //       </div>

// //       <div className="leads-toolbar">
// //         <input
// //           className="search-input"
// //           placeholder="Search leads by name or phone..."
// //           value={searchTerm}
// //           onChange={e => setSearchTerm(e.target.value)}
// //         />

// //         <LeadFilters filters={filters} setFilters={setFilters} />
// //       </div>

// //       {/* MODAL */}
// //       <AnimatePresence>
// //         {showForm && (
// //           <motion.div
// //             className="modal-overlay"
// //             initial={{ opacity: 0 }}
// //             animate={{ opacity: 1 }}
// //             exit={{ opacity: 0 }}
// //           >
// //             <motion.div
// //               className="modal-content"
// //               initial={{ scale: 0.9, opacity: 0 }}
// //               animate={{ scale: 1, opacity: 1 }}
// //               exit={{ scale: 0.9, opacity: 0 }}
// //             >
// //               <LeadForm
// //                 lead={editingLead}
// //                 onSave={handleSave}
// //                 onCancel={() => {
// //                   setShowForm(false);
// //                   setEditingLead(null);
// //                 }}
// //               />
// //             </motion.div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>

// //       {/* GRID */}
// //       <div className="leads-grid">
// //         {loading ? (
// //           <p>Loading...</p>
// //         ) : filteredLeads.length === 0 ? (
// //           <p>No leads found</p>
// //         ) : (
// //           filteredLeads.map((lead, index) => (
// //             <LeadCard
// //               key={lead._id}
// //               lead={lead}
// //               index={index}
// //               selected={selectedLeads.includes(lead._id)}
// //               onSelect={() =>
// //                 setSelectedLeads(prev =>
// //                   prev.includes(lead._id)
// //                     ? prev.filter(id => id !== lead._id)
// //                     : [...prev, lead._id]
// //                 )
// //               }
// //               onEdit={() => {
// //                 setEditingLead(lead);
// //                 setShowForm(true);
// //               }}
// //               onDelete={() => handleDelete(lead._id)}
// //                isAdmin={isAdmin} 
// //             />
// //           ))
// //         )}
// //       </div>

// //       <BulkEmailDialog
// //         open={showBulkEmail}
// //         leads={leads.filter(l => selectedLeads.includes(l._id))}
// //         onClose={() => setShowBulkEmail(false)}
// //       />
// //     </div>
// //   );
// // }

// // Updated: 23-05-2026
// // Changes:
// // - Reads URL query params on mount (status, interest_level, source, lead_type)
// //   so Dashboard stat cards that link with ?status=xxx correctly pre-filter the page

// import React, { useEffect, useState } from "react";
// import { Plus, Download, Mail } from "lucide-react";
// import { motion, AnimatePresence } from "framer-motion";
// import { useNavigate, useLocation } from "react-router-dom";

// import LeadCard from "../components/leads/LeadCard";
// import LeadForm from "../components/leads/LeadForm";
// import LeadFilters from "../components/leads/LeadFilters";
// import BulkEmailDialog from "../components/leads/BulkEmailDialog";

// import api from "../api/api";
// import { useAuth } from "../api/authContext";

// import "../css/leads/leadspage.css";

// export default function LeadsPage() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { token, isAdmin } = useAuth();

//   /* ── Read initial filter values from URL query params ── */
//   const initFilters = () => {
//     const p = new URLSearchParams(location.search);
//     return {
//       status:         p.get("status")         || "all",
//       lead_type:      p.get("lead_type")       || "all",
//       source:         p.get("source")          || "all",
//       interest_level: p.get("interest_level")  || "all",
//     };
//   };

//   const [leads, setLeads] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showForm, setShowForm] = useState(false);
//   const [editingLead, setEditingLead] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filters, setFilters] = useState(initFilters);
//   const [selectedLeads, setSelectedLeads] = useState([]);
//   const [showBulkEmail, setShowBulkEmail] = useState(false);

//   /* ── Re-apply filters if URL changes (e.g. dashboard link clicked again) ── */
//   useEffect(() => {
//     setFilters(initFilters());
//   }, [location.search]);

//   /* ================= AUTH GUARD ================= */
//   useEffect(() => {
//     if (!token) {
//       navigate("/login");
//       return;
//     }
//     fetchLeads();
//   }, [token]);

//   /* ================= FETCH ================= */
//   const fetchLeads = async () => {
//     try {
//       setLoading(true);
//       const res = await api.get("/leads/all");
//       setLeads(res.data || []);
//     } catch (err) {
//       console.error(err);
//       if (err.response?.status === 401) navigate("/login");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ================= SAVE ================= */
//   const handleSave = async (data) => {
//     try {
//       if (editingLead) {
//         await api.put(`/leads/${editingLead._id}`, data);
//       } else {
//         await api.post("/leads/create", data);
//       }
//       fetchLeads();
//       setShowForm(false);
//       setEditingLead(null);
//     } catch (err) {
//       console.error(err.response?.data || err.message);
//       alert("Error saving lead");
//     }
//   };

//   /* ================= DELETE ================= */
//   const handleDelete = async (leadId) => {
//     if (!window.confirm("Are you sure you want to delete this lead?")) return;
//     try {
//       await api.delete(`/leads/${leadId}`);
//       setLeads((prev) => prev.filter((l) => l._id !== leadId));
//       setSelectedLeads((prev) => prev.filter((id) => id !== leadId));
//     } catch (err) {
//       alert("Error deleting lead");
//     }
//   };

//   /* ================= EXPORT ================= */
//   const handleExport = () => {
//     if (!leads.length) return;
//     const csv = [
//       ["Name", "Phone", "Email", "Type", "Source", "Status", "Interest Level"],
//       ...leads.map((l) => [
//         l.full_name, l.phone, l.email, l.lead_type,
//         l.source, l.status, l.interest_level,
//       ]),
//     ]
//       .map((row) => row.map((v) => `"${v || ""}"`).join(","))
//       .join("\n");

//     const blob = new Blob([csv], { type: "text/csv" });
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = "leads.csv";
//     link.click();
//   };

//   /* ================= FILTER ================= */
//   const filteredLeads = leads.filter((l) => {
//     const search = searchTerm.toLowerCase();
//     return (
//       (l.full_name?.toLowerCase().includes(search) ||
//         l.phone?.toLowerCase().includes(search)) &&
//       (filters.status         === "all" || l.status         === filters.status) &&
//       (filters.lead_type      === "all" || l.lead_type      === filters.lead_type) &&
//       (filters.source         === "all" || l.source         === filters.source) &&
//       (filters.interest_level === "all" || l.interest_level === filters.interest_level)
//     );
//   });

//   /* ================= UI ================= */
//   return (
//     <div className="leads-page">
//       <div className="leads-header">
//         <div>
//           <h1>Lead Management</h1>
//           <p>Track and manage your leads</p>
//         </div>
//         <div className="actions">
//           {selectedLeads.length > 0 && (
//             <button onClick={() => setShowBulkEmail(true)}>
//               <Mail size={16} /> Email ({selectedLeads.length})
//             </button>
//           )}
//           <button onClick={handleExport}>
//             <Download size={16} /> Export
//           </button>
//           <button onClick={() => { setEditingLead(null); setShowForm(true); }}>
//             <Plus size={16} /> Add Lead
//           </button>
//         </div>
//       </div>

//       <div className="leads-toolbar">
//         <input
//           className="search-input"
//           placeholder="Search leads by name or phone..."
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//         <LeadFilters filters={filters} setFilters={setFilters} />
//       </div>

//       {/* MODAL */}
//       <AnimatePresence>
//         {showForm && (
//           <motion.div className="modal-overlay"
//             initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
//             <motion.div className="modal-content"
//               initial={{ scale: 0.9, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.9, opacity: 0 }}>
//               <LeadForm
//                 lead={editingLead}
//                 onSave={handleSave}
//                 onCancel={() => { setShowForm(false); setEditingLead(null); }}
//               />
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* GRID */}
//       <div className="leads-grid">
//         {loading ? (
//           <p>Loading...</p>
//         ) : filteredLeads.length === 0 ? (
//           <p>No leads found</p>
//         ) : (
//           filteredLeads.map((lead, index) => (
//             <LeadCard
//               key={lead._id}
//               lead={lead}
//               index={index}
//               selected={selectedLeads.includes(lead._id)}
//               onSelect={() =>
//                 setSelectedLeads((prev) =>
//                   prev.includes(lead._id)
//                     ? prev.filter((id) => id !== lead._id)
//                     : [...prev, lead._id]
//                 )
//               }
//               onEdit={() => { setEditingLead(lead); setShowForm(true); }}
//               onDelete={() => handleDelete(lead._id)}
//               isAdmin={isAdmin}
//             />
//           ))
//         )}
//       </div>

//       <BulkEmailDialog
//         open={showBulkEmail}
//         leads={leads.filter((l) => selectedLeads.includes(l._id))}
//         onClose={() => setShowBulkEmail(false)}
//       />
//     </div>
//   );
// }
// Updated: 23-05-2026
// Changes:
// - Reads URL query params on mount (status, interest_level, source, lead_type)
//   so Dashboard stat cards that link with ?status=xxx correctly pre-filter the page
// - Added "Created By" agent filter dropdown (built from actual lead data)

import React, { useEffect, useState, useCallback } from "react";
import { Plus, Download, Mail, UserCheck, X, TrendingUp, Calendar, CheckCircle2 } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";

import LeadCard from "../components/leads/LeadCard";
import LeadForm from "../components/leads/LeadForm";
import LeadFilters from "../components/leads/LeadFilters";
import BulkEmailDialog from "../components/leads/BulkEmailDialog";
import PeriodFilterBar from "../components/common/PeriodFilterBar";

import api from "../api/api";
import { useAuth } from "../api/authContext";
import { getPeriodRange, isDateInRange } from "../utils/periodFilter";

import "../css/leads/leadspage.css";

export default function LeadsPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { token, isAdmin } = useAuth();

  const initFilters = () => {
    const p = new URLSearchParams(location.search);
    return {
      status:         p.get("status")        || "all",
      lead_type:      p.get("lead_type")     || "all",
      source:         p.get("source")        || "all",
      interest_level: p.get("interest_level")|| "all",
    };
  };

  const [leads,          setLeads]          = useState([]);
  const [agents,         setAgents]         = useState([]);
  const [loading,        setLoading]        = useState(true);
  const [showForm,       setShowForm]       = useState(false);
  const [editingLead,    setEditingLead]    = useState(null);
  const [searchTerm,     setSearchTerm]     = useState("");
  const [filters,        setFilters]        = useState(initFilters);
  const [createdBy,      setCreatedBy]      = useState("all");
  const [period,         setPeriod]         = useState("all");
  const [weekAnchor,     setWeekAnchor]     = useState(() => new Date());
  const [customFrom,     setCustomFrom]     = useState("");
  const [customTo,       setCustomTo]       = useState("");
  // LIFO by default — most recently added lead shows first
  const [sortBy,         setSortBy]         = useState("createdDate");
  const [sortDir,        setSortDir]        = useState("desc");
  const [selectedLeads,  setSelectedLeads]  = useState([]);
  const [showBulkEmail,  setShowBulkEmail]  = useState(false);

  // Assign modal state
  const [assigningLead,  setAssigningLead]  = useState(null);
  const [selectedAgent,  setSelectedAgent]  = useState("");
  const [assigning,      setAssigning]      = useState(false);

  // Convert Lead to Deal state
  const [convertingLead, setConvertingLead] = useState(null);
  const [convertDealData, setConvertDealData] = useState({
    dealName: "", dealValue: "", commission: "", probability: "", closeDate: "", status: "matured"
  });
  const [convertingDeal, setConvertingDeal] = useState(false);

  useEffect(() => { setFilters(initFilters()); }, [location.search]);

  useEffect(() => {
    if (!token) { navigate("/login"); return; }
    fetchLeads();
    if (isAdmin) fetchAgents();
  }, [token]);

  const fetchLeads = async () => {
    try {
      setLoading(true);
      const res = await api.get("/leads/all");
      setLeads(res.data || []);
    } catch (err) {
      if (err.response?.status === 401) navigate("/login");
    } finally {
      setLoading(false);
    }
  };

  const fetchAgents = async () => {
    try {
      const res = await api.get("/users");
      setAgents((res.data || []).filter(u => u.role === "agent" || u.role === "admin"));
    } catch (_) {}
  };

  const handleSave = async (data) => {
    try {
      let response;
      if (editingLead) {
        response = await api.put(`/leads/${editingLead._id}`, data);
      } else {
        response = await api.post("/leads/create", data);
      }

      // Check if lead was automatically converted to a deal (status changed to "matured")
      if (response.data?.deal) {
        alert(
          "✅ Lead updated successfully!\n\n" +
          response.data.dealMessage ||
          "Lead status changed to 'Matured' and a Deal has been automatically created."
        );
      }

      fetchLeads();
      setShowForm(false);
      setEditingLead(null);
    } catch (err) {
      alert("Error saving lead: " + (err.response?.data?.message || err.message));
    }
  };

  const handleDelete = async (leadId) => {
    if (!window.confirm("Are you sure you want to delete this lead?")) return;
    try {
      await api.delete(`/leads/${leadId}`);
      setLeads(prev => prev.filter(l => l._id !== leadId));
      setSelectedLeads(prev => prev.filter(id => id !== leadId));
    } catch (_) { alert("Error deleting lead"); }
  };

  // ── Assign lead to agent ─────────────────────────────────────────────────
  const openAssign = (lead) => {
    setAssigningLead(lead);
    setSelectedAgent(lead.assignedTo || "");
  };

  const handleAssign = async () => {
    if (!assigningLead) return;
    setAssigning(true);
    try {
      await api.patch(`/leads/${assigningLead._id}/assign`, { agentId: selectedAgent || null });
      setAssigningLead(null);
      setSelectedAgent("");
      fetchLeads();
    } catch (err) {
      alert("Failed to assign: " + (err.response?.data?.message || err.message));
    } finally {
      setAssigning(false);
    }
  };

  // ── Convert Lead to Deal ────────────────────────────────────────────────
  const openConvertDeal = (lead) => {
    setConvertingLead(lead);
    setConvertDealData({
      dealName: `${lead.full_name} - Deal`,
      dealValue: "",
      commission: "",
      probability: "50",
      closeDate: "",
      status: "matured"  // Default to "matured" when converting to deal
    });
  };

  const handleConvertDealSubmit = async (e) => {
    e.preventDefault();
    if (!convertDealData.dealName) {
      alert("Deal name is required");
      return;
    }
    setConvertingDeal(true);
    try {
      // First, update the lead status if it's different from current
      if (convertDealData.status && convertDealData.status !== convertingLead.status) {
        const statusResponse = await api.put(`/leads/${convertingLead._id}`, {
          status: convertDealData.status
        });

        // If deal was automatically created from "matured" status, use that
        if (statusResponse.data?.deal) {
          alert(
            "✅ Lead Status Updated!\n\n" +
            "Lead status changed to '" + convertDealData.status + "' and a Deal has been automatically created.\n" +
            "You can now manage it in the Deals module."
          );
          setConvertingLead(null);
          fetchLeads();
          return;
        }
      }

      // If status wasn't "matured" or didn't auto-create deal, create deal manually
      await api.post("/deals", {
        dealName: convertDealData.dealName,
        leadID: convertingLead._id,
        propertyID: convertingLead.propertyId || null,
        dealValue: convertDealData.dealValue ? Number(convertDealData.dealValue) : null,
        commissionAmout: convertDealData.commission ? Number(convertDealData.commission) : null,
        winProbability: convertDealData.probability ? Number(convertDealData.probability) : 50,
        expectedCloseDate: convertDealData.closeDate || null,
        notes: `Converted from lead: ${convertingLead.full_name}`,
        assignedtoEmail: convertingLead.assignedToEmail || "",
      });

      setConvertingLead(null);
      fetchLeads();
      alert("✅ Lead successfully converted to deal!\nLead status: " + (convertDealData.status || "updated"));
    } catch (err) {
      alert("Failed to convert: " + (err.response?.data?.message || err.message));
    } finally {
      setConvertingDeal(false);
    }
  };

  const handleExport = () => {
    if (!leads.length) return;
    const csv = [
      ["Name", "Phone", "Email", "Type", "Source", "Status", "Interest", "Assigned To"],
      ...leads.map(l => [
        l.full_name, l.phone, l.email, l.lead_type,
        l.source, l.status, l.interest_level, l.assignedToEmail || "",
      ]),
    ].map(r => r.map(v => `"${v || ""}"`).join(",")).join("\n");

    const link = document.createElement("a");
    link.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
    link.download = "leads.csv";
    link.click();
  };

  const agentOptions = [...new Set(leads.map(l => l.createdByEmail).filter(Boolean))].sort();
  const periodRange  = getPeriodRange(period, { weekAnchor, customFrom, customTo });
  const closedCount  = leads.filter(l => l.status === "closed").length;
  const isClosedFilterActive = filters.status === "closed";
  const toggleClosedFilter = () =>
    setFilters(prev => ({ ...prev, status: prev.status === "closed" ? "all" : "closed" }));

  const filteredLeads = leads.filter(l => {
    const s = searchTerm.toLowerCase();
    return (
      (l.full_name?.toLowerCase().includes(s) || l.phone?.toLowerCase().includes(s)) &&
      (filters.status         === "all" || l.status         === filters.status) &&
      (filters.lead_type      === "all" || l.lead_type      === filters.lead_type) &&
      (filters.source         === "all" || l.source         === filters.source) &&
      (filters.interest_level === "all" || l.interest_level === filters.interest_level) &&
      (createdBy              === "all" || l.createdByEmail === createdBy) &&
      isDateInRange(l.createdDate, periodRange)
    );
  }).sort((a, b) => {
    if (sortBy === "createdDate") {
      const diff = new Date(a.createdDate || 0) - new Date(b.createdDate || 0);
      return sortDir === "asc" ? diff : -diff;
    }
    const cmp = (a.full_name || "").localeCompare(b.full_name || "");
    return sortDir === "asc" ? cmp : -cmp;
  });

  return (
    <div className="leads-page">
      <div className="leads-header">
        <div>
          <h1>Lead Management</h1>
          <p>Track and manage your leads</p>
        </div>
        <div className="actions">
          {selectedLeads.length > 0 && (
            <button onClick={() => setShowBulkEmail(true)}>
              <Mail size={16} /> Email ({selectedLeads.length})
            </button>
          )}
          <button onClick={handleExport}>
            <Download size={16} /> Export
          </button>
          <button onClick={() => { setEditingLead(null); setShowForm(true); }}>
            <Plus size={16} /> Add Lead
          </button>
        </div>
      </div>

      <PeriodFilterBar
        period={period} onPeriodChange={setPeriod}
        weekAnchor={weekAnchor} onWeekAnchorChange={setWeekAnchor}
        customFrom={customFrom} onCustomFromChange={setCustomFrom}
        customTo={customTo} onCustomToChange={setCustomTo}
        sortBy={sortBy} onSortByChange={setSortBy}
        sortDir={sortDir} onSortDirChange={setSortDir}
        sortOptions={[
          { value: "name",        label: "Name" },
          { value: "createdDate", label: "Created Date" },
        ]}
      />

      <div className="leads-toolbar">
        <input
          className="search-input"
          placeholder="Search leads by name or phone..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
        />
        <LeadFilters filters={filters} setFilters={setFilters} />
        <select className="filter-select" value={createdBy} onChange={e => setCreatedBy(e.target.value)}>
          <option value="all">All Agents</option>
          {agentOptions.map(email => <option key={email} value={email}>{email}</option>)}
        </select>
        <button
          type="button"
          className={`closed-leads-chip ${isClosedFilterActive ? "active" : ""}`}
          onClick={toggleClosedFilter}
          title={isClosedFilterActive ? "Showing closed leads only — click to clear" : "Show closed leads only"}
        >
          <CheckCircle2 size={14} />
          Closed Leads
          <span className="closed-leads-count">{closedCount}</span>
        </button>
      </div>

      {/* ── Lead form modal ── */}
      <AnimatePresence>
        {showForm && (
          <motion.div className="modal-overlay"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
            <motion.div className="modal-content"
              initial={{ scale: 0.9, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.9, opacity: 0 }}>
              <LeadForm
                lead={editingLead}
                onSave={handleSave}
                onCancel={() => { setShowForm(false); setEditingLead(null); }}
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* ── Assign Lead modal ── */}
      {assigningLead && (
        <div className="modal-overlay" onClick={() => setAssigningLead(null)}>
          <div className="assign-modal" onClick={e => e.stopPropagation()}>
            <div className="assign-modal-header">
              <div>
                <h3>Assign Lead</h3>
                <p>{assigningLead.full_name}</p>
              </div>
              <button className="assign-close-btn" onClick={() => setAssigningLead(null)}>
                <X size={18} />
              </button>
            </div>
            <div className="assign-modal-body">
              <label>Select Agent</label>
              <select
                value={selectedAgent}
                onChange={e => setSelectedAgent(e.target.value)}
                className="assign-select"
              >
                <option value="">— Unassigned —</option>
                {agents.map(a => (
                  <option key={a._id} value={a._id}>
                    {a.Name} ({a.email})
                  </option>
                ))}
              </select>
              {assigningLead.assignedToEmail && (
                <p className="current-assignee">
                  Currently assigned to: <strong>{assigningLead.assignedToEmail}</strong>
                </p>
              )}
            </div>
            <div className="assign-modal-footer">
              <button className="btn btn-outline" onClick={() => setAssigningLead(null)}>Cancel</button>
              <button className="btn btn-primary" onClick={handleAssign} disabled={assigning}>
                <UserCheck size={14} />
                {assigning ? "Assigning…" : "Assign Lead"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Convert Lead to Deal modal ── */}
      {convertingLead && (
        <div className="modal-overlay" onClick={() => setConvertingLead(null)}>
          <div className="assign-modal" onClick={e => e.stopPropagation()}>
            <div className="assign-modal-header">
              <div>
                <TrendingUp size={20} style={{ color: "#1D4ED8" }} />
                <div>
                  <h3>Convert to Deal</h3>
                  <p>Creating a deal from <strong>{convertingLead.full_name}</strong>'s lead</p>
                </div>
              </div>
              <button className="assign-close-btn" onClick={() => setConvertingLead(null)}>
                <X size={18} />
              </button>
            </div>
            <form onSubmit={handleConvertDealSubmit}>
              <div className="assign-modal-body" style={{ maxHeight: "500px", overflowY: "auto" }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "12px" }}>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label style={{ fontSize: "12px", fontWeight: "600", marginBottom: "4px" }}>Deal Name *</label>
                    <input
                      type="text"
                      value={convertDealData.dealName}
                      onChange={e => setConvertDealData(prev => ({ ...prev, dealName: e.target.value }))}
                      className="assign-select"
                      required
                    />
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label style={{ fontSize: "12px", fontWeight: "600", marginBottom: "4px" }}>Deal Value (₹)</label>
                    <input
                      type="number"
                      value={convertDealData.dealValue}
                      onChange={e => setConvertDealData(prev => ({ ...prev, dealValue: e.target.value }))}
                      className="assign-select"
                      placeholder="0"
                    />
                  </div>
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "12px" }}>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label style={{ fontSize: "12px", fontWeight: "600", marginBottom: "4px" }}>Commission (₹)</label>
                    <input
                      type="number"
                      value={convertDealData.commission}
                      onChange={e => setConvertDealData(prev => ({ ...prev, commission: e.target.value }))}
                      className="assign-select"
                      placeholder="0"
                    />
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label style={{ fontSize: "12px", fontWeight: "600", marginBottom: "4px" }}>Win Probability (%)</label>
                    <input
                      type="number"
                      min="0"
                      max="100"
                      value={convertDealData.probability}
                      onChange={e => setConvertDealData(prev => ({ ...prev, probability: e.target.value }))}
                      className="assign-select"
                    />
                  </div>
                </div>

                <div style={{ display: "flex", flexDirection: "column", marginBottom: "12px" }}>
                  <label style={{ fontSize: "12px", fontWeight: "600", marginBottom: "4px" }}>Expected Close Date</label>
                  <input
                    type="date"
                    value={convertDealData.closeDate}
                    onChange={e => setConvertDealData(prev => ({ ...prev, closeDate: e.target.value }))}
                    className="assign-select"
                  />
                </div>

                <div style={{ display: "flex", flexDirection: "column", marginBottom: "12px" }}>
                  <label style={{ fontSize: "12px", fontWeight: "600", marginBottom: "4px" }}>Update Lead Status</label>
                  <select
                    value={convertDealData.status}
                    onChange={e => setConvertDealData(prev => ({ ...prev, status: e.target.value }))}
                    className="assign-select"
                  >
                    <option value="new">New</option>
                    <option value="contacted">Contacted</option>
                    <option value="interested">Interested</option>
                    <option value="follow_up">Follow-up</option>
                    <option value="matured">Matured (Auto-create Deal)</option>
                    <option value="closed">Closed</option>
                    <option value="lost">Lost</option>
                  </select>
                </div>

                {convertingLead.propertyId && (
                  <div style={{ backgroundColor: "#EFF6FF", padding: "8px 12px", borderRadius: "6px", marginBottom: "12px", fontSize: "12px", color: "#1D4ED8" }}>
                    ✓ Property linked: <strong>{convertingLead.propertyId?.propertyName || "Linked property"}</strong>
                  </div>
                )}
              </div>

              <div className="assign-modal-footer">
                <button type="button" className="btn btn-outline" onClick={() => setConvertingLead(null)}>Cancel</button>
                <button type="submit" className="btn btn-primary" disabled={convertingDeal}>
                  <TrendingUp size={14} />
                  {convertingDeal ? "Converting…" : "Convert to Deal"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ── Leads grid ── */}
      <div className="leads-grid">
        {loading ? (
          <p className="leads-loading">Loading leads…</p>
        ) : filteredLeads.length === 0 ? (
          <p className="leads-empty">No leads found</p>
        ) : (
          filteredLeads.map((lead, index) => (
            <LeadCard
              key={lead._id}
              lead={lead}
              index={index}
              selected={selectedLeads.includes(lead._id)}
              onSelect={() =>
                setSelectedLeads(prev =>
                  prev.includes(lead._id)
                    ? prev.filter(id => id !== lead._id)
                    : [...prev, lead._id]
                )
              }
              onEdit={() => { setEditingLead(lead); setShowForm(true); }}
              onDelete={() => handleDelete(lead._id)}
              onConvertToDeal={() => openConvertDeal(lead)}
              onAssign={isAdmin ? () => openAssign(lead) : null}
              isAdmin={isAdmin}
            />
          ))
        )}
      </div>

      <BulkEmailDialog
        open={showBulkEmail}
        leads={leads.filter(l => selectedLeads.includes(l._id))}
        onClose={() => setShowBulkEmail(false)}
      />
    </div>
  );
}